/**
 * 将 http 替换成 https
 */
export const forceHttps = (url?: string) => {
  if (!url) return '';
  return url.replace(/^http:\/\//, 'https://');
};